import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccesoPersonaService } from 'src/app/services/acceso-personal/acceso-persona.service';

@Component({
  selector: 'app-acceso-codigo-dialog',
  templateUrl: './acceso-codigo-dialog.component.html',
  styleUrls: ['./acceso-codigo-dialog.component.css']
})
export class AccesoCodigoDialogComponent implements OnInit {

  constructor(
    private accesoPersonaService: AccesoPersonaService,
    public dialogRef: MatDialogRef<AccesoCodigoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public model: number
  ) { }

  ngOnInit(): void {
    this.getImageFromService();
  }

  imageToShow: any;
  isImageLoading: boolean = false;

  createImageFromBlob(image: Blob) {
   let reader = new FileReader();
   reader.addEventListener("load", () => {
      this.imageToShow = reader.result;
   }, false);

   if (image) {
      reader.readAsDataURL(image);
   }
  }

  getImageFromService() {
    this.isImageLoading = true;
    this.accesoPersonaService.getImage(this.model).subscribe(data => {
      this.createImageFromBlob(data);
      this.isImageLoading = false;
    }, error => {
      this.isImageLoading = false;
      console.log(error);
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
